import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { configureApi, configureApiGet } from './api';

const initialState = {
  loading: false,
  users: [],
  roles: []
};

const actions = {
  CREATE_CLIENT: 'configure/CREATE_CLIENT',
  CREATE_PROJECT: 'configure/CREATE_PROJECT',
  CREATE_USER: 'configure/CREATE_USER',
  GET_USER: 'configure/GET_USER',
  GET_ROLES: 'configure/GET_ROLES',
  GET_COUNTS: 'configure/GET_COUNTS'
};

export const createClient = createAsyncThunk(
  actions.CREATE_CLIENT,
  async (payload) => {
    const response = await configureApi('clients/create-client', payload);
    return response;
  }
);
export const createProject = createAsyncThunk(
  actions.CREATE_PROJECT,
  async (payload) => {
    const response = await configureApi('projects/create-project', payload);
    return response;
  }
);
export const createUser = createAsyncThunk(
  actions.CREATE_USER,
  async (payload) => {
    const response = await configureApi('users/create-user', payload);
    return response;
  }
);
export const getUsers = createAsyncThunk(actions.GET_USER, async (payload) => {
  const response = await configureApiGet('users/user-list', payload);
  return response;
});

export const getRoles = createAsyncThunk(actions.GET_ROLES, async (payload) => {
  const response = await configureApiGet('users/role-masters', payload);
  return response;
});

export const getActiveCounts = createAsyncThunk(
  actions.GET_COUNTS,
  async (payload) => {
    const response = await configureApiGet('clients/active-counts', payload);
    return response;
  }
);

export const configureSlice = createSlice({
  name: 'configure',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createClient.pending, (state) => {
        state.loading = true;
      })
      .addCase(createClient.fulfilled, (state, action) => {
        state.loading = false;

        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(createClient.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
    builder
      .addCase(createProject.pending, (state) => {
        state.loading = true;
      })
      .addCase(createProject.fulfilled, (state, action) => {
        state.loading = false;

        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(createProject.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
    builder
      .addCase(createUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.loading = false;

        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(createUser.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(getUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.loading = false;

        const { success, message: msg, data, pagination } = action.payload;
        if (success) {
          state.users = data;
          state.pagination = {
            current: pagination.current_page,
            pageSize: pagination.total_perpage,
            total: pagination.total_records
          };
        } else {
          message.error(msg);
        }
      })
      .addCase(getUsers.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(getRoles.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRoles.fulfilled, (state, action) => {
        state.loading = false;

        const { success, message: msg, data } = action.payload;
        if (success) {
          state.roles = data;
        } else {
          message.error(msg);
        }
      })
      .addCase(getRoles.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(getActiveCounts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getActiveCounts.fulfilled, (state, action) => {
        state.loading = false;

        const { success, message: msg } = action.payload;
        if (!success) {
          message.error(msg);
        }
      })
      .addCase(getActiveCounts.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
  }
});

export const selectConfigureSlice = (state) => {
  return state.configure;
};

export default configureSlice.reducer;
